import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IDatabaseCertificationParams {
  id: string;
  luid?: string;
  isCertified: boolean;
  certificationNote: string;
}

export class SetDatabaseCertificationRequest extends Request<IDatabaseCertificationParams, IResult> {
  constructor(params: IDatabaseCertificationParams) {
    super('setDatabaseCertification', params);
  }
}
